import { api } from './api';

export interface EmailSettings {
  userId: string;
  readingPanePosition: 'right' | 'bottom' | 'off';
  density: 'compact' | 'comfortable';
  conversationMode: boolean;
  autoMarkReadOnOpen: boolean;
  undoSendWindowSeconds: number;
  defaultReplyBehaviour: 'reply' | 'reply_all';
  showExternalImages: 'always' | 'block' | 'ask';
  quietHoursEnabled: boolean;
  quietHoursStart: string | null;
  quietHoursEnd: string | null;
  digestMode: 'immediate' | 'hourly' | 'daily';
  vacationResponderEnabled: boolean;
  vacationResponderMessage: string | null;
  vacationResponderFrom: string | null;
  vacationResponderTo: string | null;
  updatedAt: string;
}

export async function fetchEmailSettings(): Promise<EmailSettings> {
  const res = await api.get('/inbox/settings');
  return res.data;
}

export async function updateEmailSettings(
  input: Partial<Omit<EmailSettings, 'userId' | 'updatedAt'>>,
): Promise<EmailSettings> {
  const res = await api.patch('/inbox/settings', input);
  return res.data;
}
